import { NgModule } from '@angular/core';
import { RawPipe } from './raw/raw';
//import { BoldprefixPipe } from './boldprefix/boldprefix';
@NgModule({
	declarations: [RawPipe/*BoldprefixPipe*/],
	imports: [],
	exports: [RawPipe/*BoldprefixPipe*/]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts